import { render } from "./Project-3.vue?vue&type=template&id=696f02b3"
import script from "./Project-3.vue?vue&type=script&lang=js"
export * from "./Project-3.vue?vue&type=script&lang=js"
script.render = render

export default script